import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useMasterApprenticesStore } from '../store';

export const useMasterApprenticesTable = () => {
  const { districtId } = useParams();
  const {
    masterApprentices,
    fetchMasterApprentices,
    isMasterApprenticesLoading,
  } = useMasterApprenticesStore();

  useEffect(() => {
    fetchMasterApprentices(districtId!);
  }, []);

  const columns = [
    { key: 'id', label: '#' },
    { key: 'master_name', label: 'Ustozlar' },
    { key: 'apprentices_count', label: "Shogird fermer xo'jaliklari" },
  ];

  return {
    columns,
    masterApprentices,
    isMasterApprenticesLoading,
  };
};
